import type { BadgeTone } from '@/shared/ui/Badge';

const tomPorTipo: Record<string, BadgeTone> = {
  inicial: 'info',
  andamento: 'warning',
  aprovado: 'success',
  reprovado: 'danger',
  cancelado: 'neutral',
};

/** Cor da coluna pelo tipo da etapa, que vale tambem para a esteira configurada. */
export function tomDaColuna(tipo: string): BadgeTone {
  return tomPorTipo[tipo] ?? 'neutral';
}

/** Titulo do cartao: o numero da cotacao, ou o tipo do pedido. */
export function tituloDoCartao(cartao: {
  title: string;
  operation: { number: number; proposal_number: string } | null;
}): string {
  if (cartao.operation) {
    return `Cotacao ${cartao.operation.proposal_number || cartao.operation.number}`;
  }
  return cartao.title || 'Cartao';
}

/**
 * Titulo da gaveta pelo objeto do cartao (P-EST-2): "Dados da cotacao" e "Dados da
 * Solicitacao de Nomeacao", como no OnPoint; o cartao de revisao de limite e o de
 * tomador seguem o mesmo padrao.
 */
export function tituloDaGaveta(cartao: { subject_type: string }): string {
  switch (cartao.subject_type) {
    case 'nomeacao':
      return 'Dados da Solicitacao de Nomeacao';
    case 'revisao_limite':
      return 'Dados da Revisao de Limite';
    case 'tomador':
      return 'Dados do tomador';
    case 'autocadastro_corretora':
      return 'Dados do Autocadastro da Corretora';
    default:
      return 'Dados da cotacao';
  }
}

/**
 * Esteiras em que a pessoa abre o cartao no quadro (P-EST-2): Cadastro (o tomador), PEP
 * e Resseguro (a cotacao). Credito e Subscricao abrem pela etapa da operacao, e
 * Nomeacao, pelo pedido.
 */
export function abreCartaoNoQuadro(pipe: { key: string } | undefined): boolean {
  return pipe !== undefined && ['cadastro', 'pep', 'resseguro'].includes(pipe.key);
}

/**
 * Chave de cada esteira (paridade R-3, USU-049, USU-050 e USU-052 do OnPoint): mover o
 * cartao de Resseguro, Cadastro e PEP pede, alem de esteiras.cartao.transition, a chave
 * da esteira. As outras esteiras nao tem chave propria para mover.
 */
const chaveDaEsteira: Record<string, string> = {
  resseguro: 'esteiras.resseguro.update',
  cadastro: 'esteiras.cadastro.update',
  pep: 'esteiras.pep.update',
};

/** Informa se a sessao move cartoes na esteira, com a chave dela quando houver. */
export function podeMoverNaEsteira(
  can: (permissao: string) => boolean,
  pipe: { key: string } | undefined,
): boolean {
  if (!can('esteiras.cartao.transition')) return false;
  const chave = pipe ? chaveDaEsteira[pipe.key] : undefined;
  return chave === undefined || can(chave);
}

/** O tomador do cartao, venha ele da cotacao ou do pedido. */
export function tomadorDoCartao(cartao: {
  policyholder_id?: string | null | undefined;
  operation: { policyholder: { id: string } } | null;
  subject?: { policyholder: { id: string } } | null | undefined;
}): string {
  return (
    cartao.policyholder_id ??
    cartao.operation?.policyholder.id ??
    cartao.subject?.policyholder.id ??
    ''
  );
}
